// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4199":"78c511a1","4737":"4157e60c"}[chunkId] + ".chunk.css";
};